var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Dely案件編集","user":_vm.user}},[_c('div',{attrs:{"id":"EditSpecialOffer"}},[_c('special-offer-form',{attrs:{"special-offer":_vm.specialOffer},on:{"submit":_vm.save,"cancel":_vm.cancel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }